import Page from 'src/event/[entityId]/embed/[unlisted_hash]/index';

export default Page;
